import React from 'react';
import { IconProps } from '.';

const SvgColoredStore = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#B3E3FD'
        d='M4.337 10.092 4 9.868V20h16V9.87l-.335.223a3 3 0 0 1-3.328 0L15 9.201l-1.336.89a3 3 0 0 1-3.329 0l-1.335-.89-1.336.89a3 3 0 0 1-3.328 0Z'
      />
      <path fill='#2294E3' d='M12 13a3 3 0 0 0-3 3v6h6v-6a3 3 0 0 0-3-3Z' />
      <path
        fill='#32B0F5'
        d='M2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3.796 9.732l.54.36a3 3 0 0 0 3.328 0l1.337-.89 1.335.89a3 3 0 0 0 3.329 0L15 9.202l1.336.89a3 3 0 0 0 3.328 0l.54-.36a3 3 0 0 0 1.121-3.61l-.894-2.236A3 3 0 0 0 17.647 2H6.355a3 3 0 0 0-2.786 1.886l-.894 2.236a3 3 0 0 0 1.121 3.61Z'
      />
    </svg>
  );
};

export default SvgColoredStore;
